export const currentState = [
  {
    title: 'Dopamine Bankruptcy',
    description: 'Mindless scrolling and zero attention span.',
  },
  {
    title: '3 PM Energy Crashes',
    description: 'Relying on caffeine just to survive.',
  },
  {
    title: 'Chronic Brain Fog',
    description: 'Struggling to focus for 10 minutes.',
  },
  {
    title: 'Hormonal Imbalance',
    description: 'Low motivation and persistent irritability.',
  },
]

export const biologicEdge = [
  {
    title: 'Deep Work Capacity',
    description: "Enter 'Flow State' at will and double your output.",
  },
  {
    title: 'Sustained Vitality',
    description: 'Clean, natural energy from sunrise to sunset.',
  },
  {
    title: 'High-Definition Clarity',
    description: 'Sharp thinking and absolute mental control.',
  },
  {
    title: 'Optimized Drive',
    description: 'A biology that supports your highest goals.',
  },
]
